/**
 * Docs layout route — wraps all /docs/* pages with sidebar + PublicLayout.
 *
 * Two-column layout: fixed sidebar (240px) + scrollable content area.
 * Mobile: hamburger toggle opens sidebar as a Sheet overlay.
 */

import { createFileRoute, Outlet } from "@tanstack/react-router";
import { DocsMobileSidebar, DocsSidebar } from "@/components/docs/docs-sidebar";
import { PublicLayout } from "@/components/public-layout";
import { buildLinks, buildMetaTags, getCanonical } from "@/lib/seo/meta";

export const Route = createFileRoute("/docs")({
	head: () => {
		const canonical = getCanonical("/docs");
		const meta = buildMetaTags({
			title: "Documentation",
			description: "Developer documentation for the m8tes Python SDK and REST API.",
			ogType: "website",
		});
		return { meta, links: buildLinks({ canonical }) };
	},
	component: DocsLayout,
});

function DocsLayout() {
	return (
		<PublicLayout>
			<div className="mx-auto flex w-full max-w-6xl gap-10 px-4 py-10 sm:px-6 lg:px-8">
				<aside className="hidden w-60 shrink-0 lg:block">
					<DocsSidebar />
				</aside>
				<main className="min-w-0 flex-1">
					<div className="mb-4 lg:hidden">
						<DocsMobileSidebar />
					</div>
					<Outlet />
				</main>
			</div>
		</PublicLayout>
	);
}
